import { colors } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import PercentageImage from '../../../images/eod-percentage.png';

export type YuhoCampaignBannerProps = {
  children: React.ReactNode;
};

const StyledBanner = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
  padding: 12px 84px 12px 16px;
  height: 72px;
  background: ${colors.lime8};
  border-radius: 8px;
  color: #189908;
  overflow: hidden;

  &::before,
  &::after {
    content: '';
    position: absolute;
  }

  &::before {
    right: -124px;
    top: -91px;
    width: 208px;
    height: 208px;
    box-shadow: 0 4px 40px 0 ${colors.lime16} inset;
    border-radius: 50%;
    opacity: 1;
  }

  &::after {
    inset-inline-end: 0;
    inset-block-end: 0;
    width: 88px;
    height: 72px;
    background: url(${PercentageImage}) no-repeat center;
    background-size: cover;
  }
`;

export const EndOfDayCampaignBanner = ({ children }: YuhoCampaignBannerProps) => (
  <StyledBanner>{children}</StyledBanner>
);
